import * as React from 'react';
import { MenuItemContent, IMenuItemRenderProps } from '../common';
import { CursorType } from '../common/types';

interface IReplaceMenuItemProps extends Omit<IMenuItemRenderProps, 'onSelect'> {
    className?: string;
    cursorType?: CursorType;
    onSelect?(id: string): void;
    onRenderItem?(renderProps: IMenuItemRenderProps): React.ReactNode;
}

export const ReplaceMenuItem = React.memo((props: IReplaceMenuItemProps) => {
    const { itemInfo, hasChildren, onSelect, onRenderItem, ...rest } = props;

    const _onSelect = React.useCallback(() => {
        if (onSelect) {
            onSelect(itemInfo.id);
        }
    }, [itemInfo.id, onSelect]);

    return (
        <React.Fragment>
            {
                onRenderItem
                    ? onRenderItem({ ...rest, hasChildren, itemInfo, onSelect: _onSelect })
                    : <MenuItemContent
                        {...rest}
                        hasChildren={hasChildren}
                        itemInfo={itemInfo}
                        onSelect={_onSelect} />
            }
        </React.Fragment>
    );
});

ReplaceMenuItem.displayName = 'ReplaceMenuItem';
